namespace Entities {
    export class None
        implements RavenDocument {
        
        id = "_local/None";
    }
}